import { Pipe, PipeTransform } from '@angular/core';
import { updateList } from '../../post-login/services/software.service.model';

@Pipe({
  name: 'softwarePendingUpdate'
})
export class SoftwarePendingUpdatePipe implements PipeTransform {

  transform(assets: Array<updateList>, isAll: boolean): Array<updateList> {
    if (isAll) {
      return assets;
    } else {
      let _assets: Array<updateList> = [];
      assets.forEach( asset => {
        if (asset.pending == 'true') {
          _assets.push(asset);
        }
      });
      return _assets;
    }
  }

}
